import React, { FC, useContext } from "react";
import TopBar from "components/tableComponents/topBar";
import Banner from "components/banner";
import ExternalMembershipTable from "components/tableComponents/externalMembershipTable";
import VKButton from "components/vkButton";
import { ModalContext } from "contexts/modals";
import CreateExternalMembership from "components/drawers/createExternalMembership";
import { usePaginationStore } from "utils/usePaginationStore";
import SearchFilterField from "components/searchFilterField";
import CommunityFilterInput from "components/searchFilterComponents/communityFilter";
import { LocalizeText } from "components/localizer";

const ExternalMembershipsView: FC = () => {
    const pagination = usePaginationStore("external-memberships", undefined, {
        agreement_type: "external_member",
        page_size: 20,
        default_page_size: 20,
        is_archived: false,
    });

    const { openDrawer } = useContext(ModalContext);

    return (
        <div className="contentWrapper">
            <Banner
                title="externalMemberships"
                subTitle="bannerExternalMemberships"
                imageStyle={{ objectPosition: "60% 40%" }}
                image={`${process.env.PUBLIC_URL}/assets/images/arenaStaff/membershipAgreements.jpg`}
            />
            <TopBar
                searchField={
                    <SearchFilterField
                        pagination={pagination}
                        validator="membership"
                        label={<LocalizeText tag="searchExternalMemberships" />}
                        filterFields={<CommunityFilterInput pagination={pagination} />}
                    />
                }
                singleItem={
                    <VKButton
                        tag="createNew"
                        variant="outlined"
                        size="small"
                        onClick={() =>
                            openDrawer(
                                CreateExternalMembership,
                                { community_type: "arena", requireAgreementDocument: false, pagination: pagination },
                                "createNewExternalMembership"
                            )
                        }
                    />
                }
            />
            <ExternalMembershipTable pagination={pagination} agreement_type="external_member" />
        </div>
    );
};

export default ExternalMembershipsView;
